import { z } from 'zod';

import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';

import { templateStudioSchema } from '../../../validation-schema';

const BUY_ONE_GET_MANY_DEFAULT_FREE_TILES_LAYOUT: 1 | 2 | 3 = 3;
const BUY_ONE_GET_MANY_DEFAULT_MAX_OFFERS = 10;
const BUY_ONE_GET_MANY_DEFAULT_UNLIMITED = true;

type BuyOneGetManyBlockConfig = NonNullable<
  z.infer<typeof templateStudioSchema>['buyOneGetMany']
>;

const valueOrDefault = <T>(current: T | undefined, fallback: T): T => {
  if (current === undefined) return fallback;
  return current;
};

const DEFAULT_BUY_ONE_GET_MANY_CONFIG: BuyOneGetManyBlockConfig = {
  desktopLayout: ETemplateStudioLayoutOptions.VERTICAL,
  themes: [],
  selectedDesignId: '',
  freeTilesLayout: BUY_ONE_GET_MANY_DEFAULT_FREE_TILES_LAYOUT,
  maxOffers: BUY_ONE_GET_MANY_DEFAULT_MAX_OFFERS,
  unlimited: BUY_ONE_GET_MANY_DEFAULT_UNLIMITED
};

export const seedBuyOneGetManyConfig = (
  currentValue: Partial<BuyOneGetManyBlockConfig> | undefined
): BuyOneGetManyBlockConfig | null => {
  if (!currentValue) return DEFAULT_BUY_ONE_GET_MANY_CONFIG;

  const isMissingMaxOffers = currentValue.maxOffers === undefined;
  const isMissingUnlimited = currentValue.unlimited === undefined;
  if (!isMissingMaxOffers && !isMissingUnlimited) return null;

  return {
    ...(currentValue as BuyOneGetManyBlockConfig),
    maxOffers: valueOrDefault(
      currentValue.maxOffers,
      BUY_ONE_GET_MANY_DEFAULT_MAX_OFFERS
    ),
    unlimited: valueOrDefault(
      currentValue.unlimited,
      BUY_ONE_GET_MANY_DEFAULT_UNLIMITED
    )
  };
};
